import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

/**
 * Hook for CRUD operations on categories (admin panel)
 */
export const useCategorias = () => {
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCategorias = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const { data, error } = await supabase
        .from('categorias')
        .select('id, nomCategoria, activo')
        .order('nomCategoria', { ascending: true });

      if (error) throw error;
      setCategorias(data || []);
    } catch (err) {
      console.error('Error fetching categorias:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategorias();
  }, []);

  const createCategoria = async (categoriaData) => {
    try {
      const { data, error } = await supabase
        .from('categorias')
        .insert([categoriaData])
        .select()
        .single();

      if (error) throw error;
      await fetchCategorias();
      return data;
    } catch (err) {
      console.error('Error creating categoria:', err);
      throw err;
    }
  };

  const updateCategoria = async (id, categoriaData) => {
    try {
      const { data, error } = await supabase
        .from('categorias')
        .update(categoriaData)
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      await fetchCategorias();
      return data;
    } catch (err) {
      console.error('Error updating categoria:', err);
      throw err;
    }
  };

  const deleteCategoria = async (id) => {
    try {
      const { error } = await supabase
        .from('categorias')
        .delete()
        .eq('id', id);

      if (error) throw error;
      await fetchCategorias();
    } catch (err) {
      console.error('Error deleting categoria:', err);
      throw err;
    }
  };

  return {
    categorias,
    loading,
    error,
    createCategoria,
    updateCategoria,
    deleteCategoria,
    refetch: fetchCategorias
  };
};
